export default __webpack_public_path__ + "static/media/volume_up_black_48dp.ff19a683.svg";